
import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { getErrorPageFromStatus } from "src/layout/ErrorPages/ErrorPages.helpers";
import { COLUMNS, FILTERS } from "./AuditLog.consts";
import DateTimeContext from "../../contexts/DateTimeContext";
import { useEffectAsync } from "@hooks";
import { get } from "../../services/api";
import useAppStore from "../../stores/appStore";
import { assistantIdSelector } from "../../stores/selectors/appSelectors";
import { capitalize } from "@utils";
import HyroTableContainer from "@hyro-components/hyro-table-container/HyroTableContainer";

const AuditLog = () => {
  let ErrorPage;
  const location = useLocation();
  const { formattedTimezone } = useContext(DateTimeContext);
  const [logs, setLogs] = useState({ rows: [], count: 0 });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const selectedAssistantId = useAppStore(assistantIdSelector);

  useEffectAsync(async () => {
    const isAdmin = location.pathname.includes("admin");
    if (!selectedAssistantId && !isAdmin) return;

    setLoading(true);
    try {
      const url = isAdmin ? "/admin/assistant/audit-log" : `/assistants/${selectedAssistantId}/audit-log`;
      const logs = await get({ endpoint: url });
      logs.rows = logs.rows.map(log => ({ ...log, timestamp: `${formattedTimezone(log.timestamp)} (Eastern)` }));
      setLogs(logs ?? { rows: [], count: 0 });
    } catch (e) {
      console.error("Error occurred while fetching audit log", e);
      ErrorPage = getErrorPageFromStatus(e.response.status);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [selectedAssistantId]);

  if (error) return <ErrorPage />;

  return (
    <HyroTableContainer
      data={logs?.rows || []}
      header={{
        showDownloadButton: true
      }}
      download={{
        fileName: "audit-log",
        fileData: logs?.rows?.map((row) => ({ ...row, timestamp: formattedTimezone(row.timestamp) })) ?? [],
        fileHeaders: [
          { key: COLUMNS.timestamp.id, label: COLUMNS.timestamp.label },
          { key: COLUMNS.assistantId.id, label: COLUMNS.assistantId.label },
          { key: COLUMNS.pageName.id, label: COLUMNS.pageName.label },
          { key: COLUMNS.actionName.id, label: COLUMNS.actionName.label },
          { key: COLUMNS.userEmail.id, label: COLUMNS.userEmail.label },
          { key: COLUMNS.statusCode.id, label: COLUMNS.statusCode.label }
        ]
      }}
      filters={{
        initialFilters: FILTERS
      }}
      table={{
        stretchHeight: true,
        loading,
      }}
      pagination={{
        showPagination: logs?.rows?.length >= 10
      }}
      columns={[
        {
          field: COLUMNS.timestamp.id, headerName: COLUMNS.timestamp.label
        },
        {
          field: COLUMNS.pageName.id,
          headerName: COLUMNS.pageName.label,
          renderCell: ({ value }) => capitalize((value ?? "").replace("-", " "))
        },
        { field: COLUMNS.userEmail.id, headerName: COLUMNS.userEmail.label },
        { field: COLUMNS.actionName.id, headerName: COLUMNS.actionName.label },
        { field: COLUMNS.statusCode.id, headerName: COLUMNS.statusCode.label },
        { field: COLUMNS.assistantId.id, headerName: COLUMNS.assistantId.label },
      ]}
      testId="audit-log"
    />
  );
};

export default AuditLog;
